import { render, staticRenderFns } from "./AllMockups.vue?vue&type=template&id=7a123373&scoped=true"
import script from "./AllMockups.vue?vue&type=script&lang=js"
export * from "./AllMockups.vue?vue&type=script&lang=js"
import style0 from "./AllMockups.vue?vue&type=style&index=0&id=7a123373&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a123373",
  null
  
)

export default component.exports